import React, { Component } from 'react';
import ContactForm from './Form';

class Contact extends Component {
	constructor(props) {
		super(props);
		this.contact = React.createRef();
	}

	componentDidMount() {
		this.props.divStart(
			this.contact.current.id,
			this.contact.current.offsetTop
		);
		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	onResize = () => {
		this.props.divStart(
			this.contact.current.id,
			this.contact.current.offsetTop
		);
	};

	render() {
		return (
			<section className="contact" id="contact" ref={this.contact}>
				<h1 className="header-primary section-heading-primary section-heading-primary--white">
					Contact
				</h1>
				<ContactForm />
			</section>
		);
	}
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js